<pbc-sorter [config]="ProjekteSorterConfig" [sorter]="projekte.sorter$ | async" (sorterChange)="projekte.sorter$.next($event)"></pbc-sorter>
